import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { State } from "./createSalesOrder.store";
import { SalesOrderInputType } from "operations/schema/schema";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();


export const asyncMutations = {
  createSalesOrder: createAppAsyncThunk(
    "createSalesOrder/createSalesOrder",
    async (
      payload: SalesOrderInputType,
      { rejectWithValue, extra: { sdk } }
    ) => {
      const { referenceWithRevision, customerShipTo, totalPrice, parts, deliveryTaxCodeId, projectReference, creditDays, countryCode, currencyCode, storeId} = payload;

      const salesOrderInput = {
        referenceWithRevision,
        customerShipTo,
        totalPrice,
        deliveryTaxCodeId,
        projectReference,
        creditDays,
        countryCode,
        storeId,
        currencyCode,
        parts: (parts ?? []).map(({ partId, name, quantity, price, isNonStock, nominalCode, costCentreCode, departmentCode }) => ({
          partId: Number(partId),
          name,
          quantity,
          price: price,
          isNonStock,
          nominalCode,
          costCentreCode,
          departmentCode
        })),
      };

      const { data, errors, queued } = await graphqlRequest(sdk.createSalesOrder, {
        thunkName: "createSalesOrder/createSalesOrder",
        variables: {
          salesOrder: salesOrderInput,
        },
      });

      if (errors) return rejectWithValue(errors);

      const summaryId = data?.createSalesOrder?.orderId;
      if (!summaryId) return rejectWithValue("Failed to create sales order");

      return { summaryId, queued };
    }
  )
};

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncMutations.createSalesOrder.pending, (state, { meta }) => {
    if (meta.queued) return state;
    state.createSalesOrderLoading = true;
    state.isDirty = false;
    return state;
  });
  builder.addCase(asyncMutations.createSalesOrder.rejected, (state, { meta }) => {
    if (meta.aborted) return state;
    state.createSalesOrderLoading = false;
    return state;
  });
  builder.addCase(asyncMutations.createSalesOrder.fulfilled, (state, { payload }) => {
    state.createSalesOrderLoading = false;
    return state;
  });
};
